module.exports = __webpack_public_path__ + "img/avatar2.b51a9afa.png";